import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { QuestionSuggestionContent } from "PFApp/components/card_tx/content/question_suggestion_content";
import { Footer } from "PFApp/components/card_tx/footer/footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type QuestionSuggestionVariantProps = Pick<
  CardTxContentProps,
  "task" | "type" | "isFeed" | "isDraft" | "handleShare" | "handleRefetchActivities"
>;

export const QuestionSuggestionVariant = ({
  task,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleRefetchActivities
}: QuestionSuggestionVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    task,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={task.private} isDraft={isDraft} />
      <QuestionSuggestionContent task={task} type={type.key} />
      <Footer participants={task.participants} />
    </>
  );
};
